import mixpanel from 'mixpanel-browser'


mixpanel.init('406f69b81f42a113baade56967f62ec1', {debug: true, ignore_dnt: true});

let env_check = process.env.NODE_ENV === 'production';
// let env_check = process.env.NODE_ENV === 'development';

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;